module.exports = __webpack_public_path__ + "img/cobra_services.2ca026e8.png";